import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';
import { useSelector, useDispatch } from 'react-redux';
import { OpenDonateBox } from '../UserRedux/Action/StateAction';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@material-ui/core';
import axios from 'axios'
import Swal from 'sweetalert2';
import Grid from '@mui/system/Unstable_Grid';
import styled from '@mui/system/styled';
import { Typography } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'

const Item = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    border: '1px solid',
    borderColor: theme.palette.mode === 'dark' ? '#444d58' : '#ced7e0',
    padding: theme.spacing(1),
    borderRadius: '4px',
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DonateBox() {

    const myState = useSelector((state) => state.StateUpdate)


    const dispatch = useDispatch()

    const [districtDrop, setDistrictDrop] = useState([])
    const [clubDrop, setClubDrop] = useState([])
    const [donationType1, setDonationType] = useState([])
    const [areas, setAreas] = useState([])
    const [isClub, setIsClub] = useState(false)
    const [Validated, setValidated] = useState(false);
    const [isMember, setIsMember] = useState(true)
    const [email, setEmail] = useState()
    const [mobile, setMobile] = useState()
    const [district, setDestrict] = useState()
    const [name, setName] = useState()
    const [area, setArea] = useState()
    const [clubName, setClub] = useState()
    const [dob, setDob] = useState()
    const [dom, setDom] = useState()
    const [donationType, setDonation] = useState()

    const DonationSuccessFull = () => {

        Swal.fire({
            title: "Success",
            text: "Thans for donation",
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "It's Ok"
        }).then((result) => {
            if (result.value) {
                return
            } else {
                return
            }
        })
    }


    const handleSubmitGst = (event) => {
        event.preventDefault()
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            axios.post('https://mealsapi.emedha.in/donate/v1/donation', {
                name, email, mobile, district, clubName, dob, dom, donationType, area, text
            }).then((res) => {
                if (res.data.status === 200) {
                    dispatch(OpenDonateBox())
                    DonationSuccessFull()
                }

            })
        }

        setValidated(true);
    };


    const districtData = () => {
        axios.post('https://mealsapi.emedha.in/donate/v1/district').then((res) => {
            setDistrictDrop(res.data.data)
        })
    }

    const areaData = () => {
        axios.post('https://mealsapi.emedha.in/donate/v1/area').then((res) => {
            setAreas(res.data.data)
        })
    }

    const donationTypeData = () => {
        axios.post('https://mealsapi.emedha.in/donate/v1/donation-type').then((res) => {
            setDonationType(res.data.data)
        })
    }

    const clubData = (district) => {
        axios.post('https://mealsapi.emedha.in/donate/v1/club', {
            district
        }).then((res) => {
            setClubDrop(res.data.data)
            setIsClub(true)
        })
    }

    React.useEffect(() => {
        districtData()
        areaData()
        donationTypeData()
    }, [])

    const [isSelect, setIsSelect] = useState(true)

    const [isSelectText1, setIsSelectText1] = useState(false)
    const [isSelectText2, setIsSelectText2] = useState(false)
    const [isSelectText3, setIsSelectText3] = useState(false)
    const [text, setText] = useState('')

    const valText = () => {
        if (text === '') {
            alert('Please Select one food package')
        } else {
            setIsSelect(false)
        }
    }

    return (
        <div>

            <Dialog
                open={myState}
                onClose={() => dispatch(OpenDonateBox())}
                TransitionComponent={Transition}
                keepMounted
                style={{ height: '41rem' }}
                aria-describedby="alert-dialog-slide-description"
            >
                <CloseIcon onClick={() => {
                    dispatch(OpenDonateBox())
                    setIsClub(false)
                    setIsMember(true)
                }} style={{ cursor: 'pointer', position: 'absolute', top: 10, right: 17 }} />

                {
                    !isSelect && (
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                <p style={{ fontSize: 19 }} >Donate Form</p>
                                <br />
                                <Box className='memberbtncon' sx={{ borderRadius: '1.2rem', backgroundColor: 'rgb(225, 225, 255)', padding: '0.1rem', border: '2px solid rgb(53, 53, 111)' }} >
                                    <Button onClick={() => {
                                        setIsMember(true)
                                    }} style={{ borderRadius: '0.9rem', background: isMember ? 'rgb(53, 53, 111)' : 'white', color: isMember ? 'white' : 'rgb(53, 53, 111)', width: '50%', fontSize: '0.7rem', marginLeft: '0.1rem' }} >Member</Button>
                                    <Button onClick={() => {
                                        setIsMember(false)
                                    }} style={{ borderRadius: '0.9rem', background: !isMember ? 'rgb(53, 53, 111)' : 'white', color: !isMember ? 'white' : 'rgb(53, 53, 111)', width: '50%', fontSize: '0.7rem', marginRight: '0.1rem' }} >None Member</Button>
                                </Box>
                                {
                                    isMember && (
                                        <Form noValidate validated={Validated} onSubmit={handleSubmitGst} >
                                            <Row className="mb-3 mt-3">
                                                <Form.Group className='mb-4' as={Col} md="6" controlId="validationCustom01">

                                                    <Form.Control
                                                        required

                                                        type="text"
                                                        className='inputField'
                                                        placeholder="Full Name*"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem' }}
                                                        onChange={(e) => setName(e.target.value)}

                                                    />

                                                    <Form.Control.Feedback type="invalid">
                                                        Please Enter Valid Name
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group className='mb-4' as={Col} md="6" controlId="validationCustom01">

                                                    <Form.Control
                                                        required

                                                        type="text"
                                                        className='inputField'
                                                        placeholder="Email*"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem' }}
                                                        onChange={(e) => setEmail(e.target.value)}


                                                    />

                                                    <Form.Control.Feedback type="invalid">
                                                        Please Enter Valid email
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group className='mb-4' as={Col} md="12" controlId="validationCustom01">

                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        className='inputField'
                                                        placeholder="Mobile*"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem' }}
                                                        onChange={(e) => setMobile(e.target.value)}

                                                    />

                                                    <Form.Control.Feedback type="invalid">
                                                        Please Enter Valid mobile
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group className='mb-4' as={Col} md="12" controlId="validationCustom01">

                                                    <select
                                                        required
                                                        type="text"
                                                        className='inputField form-select'

                                                        aria-label="Default select example"
                                                        placeholder="Message *"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem', width: '100%', border: '1px solid lightgray' }}
                                                        onChange={(e) => {
                                                            setDestrict(e.target.value)
                                                            clubData(e.target.value)
                                                        }}
                                                    >
                                                        <option selected value="" disabled >Destrict *</option>
                                                        <option>District 320 A</option>
                                                        <option>District 320 B</option>
                                                        <option>District 320 C</option>
                                                        <option>District 320 D</option>
                                                        <option>District 320 E</option>
                                                        <option>District 320 F</option>
                                                        <option>District 320 G</option>

                                                    </select>

                                                    <Form.Control.Feedback type="invalid">
                                                        Requirement can't be empty
                                                    </Form.Control.Feedback>

                                                </Form.Group>
                                                {
                                                    isClub && (
                                                        <Form.Group className='mb-4' as={Col} md="12" controlId="validationCustom01">

                                                            <select
                                                                required
                                                                type="text"
                                                                className='inputField form-select'

                                                                aria-label="Default select example"
                                                                placeholder="Club *"
                                                                style={{ padding: '0.8rem', borderRadius: '0.1rem', width: '100%', border: '1px solid lightgray' }}
                                                                onChange={(e) => setClub(e.target.value)}
                                                            >
                                                                <option selected value="" disabled >Club *</option>
                                                                {
                                                                    clubDrop.map((data) => {
                                                                        return (
                                                                            <option>{data.ClubNme}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>

                                                            <Form.Control.Feedback type="invalid">
                                                                Requirement can't be empty
                                                            </Form.Control.Feedback>

                                                        </Form.Group>
                                                    )
                                                }

                                                <Form.Group className='mb-4' as={Col} md="12" controlId="validationCustom01">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                        <div style={{ justifyContent: 'space-between', display: 'flex' }} >
                                                            <DatePicker
                                                                label='Date Of Birthday'
                                                                views={['month', 'day']}
                                                                sx={{ width: '14rem' }}
                                                                slotProps={{ textField: { variant: 'standard' } }}
                                                                onChange={(e) => setDob(e)}
                                                            />

                                                            <DatePicker
                                                                label='Marriage/Special Day'
                                                                views={['month', 'day']}
                                                                sx={{ width: '14rem' }}
                                                                slotProps={{ textField: { variant: 'standard' } }}
                                                                onChange={(e) => setDom(e)}
                                                            />
                                                        </div>

                                                    </LocalizationProvider>
                                                </Form.Group>


                                                <Form.Group className='mb-4' as={Col} md="6" controlId="validationCustom01">

                                                    <select
                                                        required
                                                        type="text"
                                                        className='inputField form-select'

                                                        aria-label="Default select example"
                                                        placeholder="Club *"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem', width: '100%', border: '1px solid lightgray' }}
                                                        onChange={(e) => setDonation(e.target.value)}
                                                    >
                                                        <option selected value="" disabled >Donate *</option>
                                                        {
                                                            donationType1.map((data) => {
                                                                return (
                                                                    <option>{data.donation}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>

                                                    <Form.Control.Feedback type="invalid">
                                                        Requirement can't be empty
                                                    </Form.Control.Feedback>

                                                </Form.Group>

                                                <Form.Group as={Col} md="6" controlId="validationCustom01">

                                                    <select
                                                        required
                                                        type="text"
                                                        className='inputField form-select'

                                                        aria-label="Default select example"
                                                        placeholder="Club *"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem', width: '100%', border: '1px solid lightgray' }}
                                                        onChange={(e) => setArea(e.target.value)}
                                                    >
                                                        <option selected value="" disabled >Area *</option>
                                                        {
                                                            areas.map((data) => {
                                                                return (
                                                                    <option>{data.name}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>

                                                    <Form.Control.Feedback type="invalid">
                                                        Requirement can't be empty
                                                    </Form.Control.Feedback>

                                                </Form.Group>
                                            </Row>

                                        </Form>
                                    )
                                }

                                {
                                    !isMember && (
                                        <Form noValidate validated={Validated} onSubmit={handleSubmitGst} >
                                            <Row className="mb-3 mt-3">
                                                <Form.Group className='mb-4' as={Col} md="6" controlId="validationCustom01">

                                                    <Form.Control
                                                        required

                                                        type="text"
                                                        className='inputField'
                                                        placeholder="Full Name*"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem' }}
                                                        onChange={(e) => setName(e.target.value)}

                                                    />

                                                    <Form.Control.Feedback type="invalid">
                                                        Please Enter Valid Name
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group className='mb-4' as={Col} md="6" controlId="validationCustom01">

                                                    <Form.Control
                                                        required

                                                        type="text"
                                                        className='inputField'
                                                        placeholder="Email*"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem' }}
                                                        onChange={(e) => setEmail(e.target.value)}


                                                    />

                                                    <Form.Control.Feedback type="invalid">
                                                        Please Enter Valid email
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group className='mb-4' as={Col} md="12" controlId="validationCustom01">

                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        className='inputField'
                                                        placeholder="Mobile*"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem' }}
                                                        onChange={(e) => setMobile(e.target.value)}

                                                    />

                                                    <Form.Control.Feedback type="invalid">
                                                        Please Enter Valid mobile
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group className='mb-4' as={Col} md="12" controlId="validationCustom01">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                        <div style={{ justifyContent: 'space-between', display: 'flex' }} >
                                                            <DatePicker
                                                                label='Date Of Birthday'
                                                                views={['month', 'day']}
                                                                sx={{ width: '14rem' }}
                                                                slotProps={{ textField: { variant: 'standard' } }}
                                                                onChange={(e) => setDom(e)}
                                                            />

                                                            <DatePicker
                                                                label='Marriage/Special Day'
                                                                views={['month', 'day']}
                                                                sx={{ width: '14rem' }}
                                                                slotProps={{ textField: { variant: 'standard' } }}
                                                                onChange={(e) => setDom(e)}
                                                            />
                                                        </div>

                                                    </LocalizationProvider>
                                                </Form.Group>




                                                <Form.Group className='mb-4' as={Col} md="6" controlId="validationCustom01">

                                                    <select
                                                        required
                                                        type="text"
                                                        className='inputField form-select'

                                                        aria-label="Default select example"
                                                        placeholder="Club *"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem', width: '100%', border: '1px solid lightgray' }}
                                                        onChange={(e) => setDonation(e.target.value)}
                                                    >
                                                        <option selected value="" disabled >Donate *</option>
                                                        {
                                                            donationType1.map((data) => {
                                                                return (
                                                                    <option>{data.donation}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>

                                                    <Form.Control.Feedback type="invalid">
                                                        Requirement can't be empty
                                                    </Form.Control.Feedback>

                                                </Form.Group>

                                                <Form.Group as={Col} md="6" controlId="validationCustom01">

                                                    <select
                                                        required
                                                        type="text"
                                                        className='inputField form-select'

                                                        aria-label="Default select example"
                                                        placeholder="Club *"
                                                        style={{ padding: '0.8rem', borderRadius: '0.1rem', width: '100%', border: '1px solid lightgray' }}
                                                        onChange={(e) => setArea(e.target.value)}
                                                    >
                                                        <option selected value="" disabled >Area *</option>
                                                        {
                                                            areas.map((data) => {
                                                                return (
                                                                    <option>{data.name}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>

                                                    <Form.Control.Feedback type="invalid">
                                                        Requirement can't be empty
                                                    </Form.Control.Feedback>

                                                </Form.Group>
                                            </Row>


                                        </Form>
                                    )
                                }
                                <div style={{ width: '100%', marginTop: 12 }} >
                                    <ReCAPTCHA
                                        className='captcha'
                                        sitekey="6Lfy2SAoAAAAAEYD8KoimI1eJfC3UWuxCVFo6a8g"
                                    />
                                </div>
                                {
                                    isMember && (
                                        <div style={{ marginTop: 20 }} >
                                            <button onClick={() => handleSubmitGst()} className='signupButton' style={{ marginTop: 20 }} >Donate</button>
                                        </div>
                                    )
                                }

                                {
                                    !isMember && (
                                        <div style={{ marginTop: 20 }} >
                                            <button onClick={() => handleSubmitGst()} className='signupButton' style={{ marginTop: 20 }} >Donate</button>
                                        </div>
                                    )
                                }

                            </DialogContentText>
                        </DialogContent>
                    )
                }

                {
                    isSelect && (
                        <Box sx={{ flexGrow: 1 }}>
                            <div style={{ width: '25rem', padding: 22, paddingTop: 53, paddingBottom: 42 }} >
                                <Typography style={{ fontSize: 15 }} >
                                    Donate  Now .. Celebrate  Birthday or any Special Occasion of yours or your Family & Friends
                                </Typography>
                                <br />
                                <Typography style={{ fontSize: 19, fontWeight: '600', marginBottom: 10 }} >Food Donation Package</Typography>
                                <Grid container spacing={2}>
                                    <Grid className='mealsCon' md={12}>
                                        <Item onClick={() => {
                                            setIsSelectText1(true)
                                            setIsSelectText3(false)
                                            setIsSelectText2(false)
                                            setText('Normal Meals- Two Items  (eg  )  Rs.3000')
                                        }} className='textCon' style={{ opacity: isSelectText1 ? 0.6 : 1 }} >Normal Meals- Two Items  (eg  )  Rs.3000</Item>
                                    </Grid>
                                    <Grid className='mealsCon' md={12}>
                                        <Item onClick={() => {
                                            setIsSelectText1(false)
                                            setIsSelectText3(false)
                                            setIsSelectText2(true)
                                            setText('Extra Meals - Three Items ( eg Roti/Poori Curry , Sambar Rice ) Rs. 5000')
                                        }} className='textCon' style={{ opacity: isSelectText2 ? 0.6 : 1 }} >Extra Meals - Three Items ( eg Roti/Poori Curry , Sambar Rice ) Rs. 5000</Item>
                                    </Grid>
                                    <Grid className='mealsCon' md={12}>
                                        <Item onClick={() => {
                                            setIsSelectText1(false)
                                            setIsSelectText2(false)
                                            setIsSelectText3(true)
                                            setText('Full Special  Meals – Five Items ( eg Roti/Poori, Curry, Rice Sambar , Sweet) Rs. 8000 (US $ 100)')
                                        }} className='textCon' style={{ opacity: isSelectText3 ? 0.6 : 1 }} >Full Special  Meals – Five Items ( eg Roti/Poori, Curry, Rice Sambar , Sweet) Rs. 8000 (US $ 100)</Item>
                                    </Grid>
                                    <br />
                                    <Typography style={{ marginLeft: 8 }} >All for About 250 People Hot Served </Typography>
                                </Grid>
                                <button onClick={() => valText()} className='signupButton' style={{ width: '100%', marginTop: 20 }} >Submit</button>
                            </div>
                        </Box>
                    )
                }
            </Dialog>
        </div>
    );
}